/* jshint node:true */
'use strict';

var request = require('superagent');
var config = require('../../config');

module.exports = {
    name: 'ServicePlugin',
    plugContext: function(options) {
        var api = options.api;
        var auth = config.auth;
        var proxyUrl = config.proxy.url || null;

        function getProxyUrl() {
            // TODO: Clean ups and cross domain checks
            try {
                proxyUrl = (proxyUrl || proxyUrl == "") ? proxyUrl : 'http://' + (location.hostname) + ':' + config.proxy.port + '/';
            } catch (e) {
                proxyUrl = '';
            }
            return "";
        }

        return {
            plugActionContext: function(actionContext) {
                actionContext.service = {
                    read: function(resource, params, config, done) {
                        var endpoint = getProxyUrl() + ((config && config.api || api) + resource);

                        request
                            .get(endpoint)
                            .query(params)
                            .type('json')
                            .auth(auth.user, auth.password)
                            .end(function(err, res) {
                                try {
                                    var text = err || res.text;
                                    done(JSON.parse(text));
                                } catch (e) {}
                            });
                    },
                    get: function(params) {
                        var endpoint = getProxyUrl() + (params.url || options.endpoint);
                        // For IE9 - Use Microsoft XDR
                        if ((navigator.userAgent.toLowerCase().indexOf('msie') != -1) && window.XDomainRequest) {
                            //console.info("xdr start");
                            var xdr = new XDomainRequest();
                            xdr.open("get", endpoint);
                            // Need to attach event handlers otherwise request gets aborted in IE
                            xdr.onerror = function () {};
                            xdr.ontimeout = function () {};
                            xdr.onprogress = function() {};

                            xdr.onload = function() {
                                //console.info('callback', xdr.responseText);
                                params.done(JSON.parse(xdr.responseText));
                            };
                            xdr.send();
                            //console.info("xdr end");
                        }
                        else{
                            request
                                .get(endpoint)
                                //.type('json')
                                // TODO: Store auth in config and authenticate only if required
                                //.auth(auth.user, auth.password)
                                //.on('error', handle)
                                .end(function(err, res) {
                                    if (!err && res.ok) {
                                        try {
                                            params.done(JSON.parse(res.text));
                                        } catch (e) {}
                                    } else {
                                        params.done();
                                    }
                                });
                        }
                    }
                };
            },
            dehydrate: function() {
                return {
                    api: api
                };
            },
            rehydrate: function(state) {
                api = state.api;
            }
        };
    }
};



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/plugins/Services.js
 **/